'use client';

import { DynamicEarnPage } from '@flipster/features/src/dynamic-earn/main-page';

const Page = () => {
  return <DynamicEarnPage />;
};

export default Page;
